import { TagList, TagsField, type TagRef } from '@bemor/web-kit/ui';
import { useState } from 'react';

/**
 * BM-46 §2.5: a case's or merchant's tags. With the permission to change them, the kit's TagsField saves each change
 * at once (and offers "Create tag" with `canCreate`); without it, the tags as colored pills.
 */
export function EntityTags({
    entity,
    tags,
    canEdit,
    canCreate,
}: {
    entity: { type: 'case' | 'merchant'; id: string };
    tags: readonly TagRef[];
    canEdit: boolean;
    canCreate: boolean;
}) {
    const [ids, setIds] = useState(() => tags.map((t) => t.id));
    if (!canEdit)
        return tags.length > 0 ? (
            <TagList tags={tags} />
        ) : (
            <span className="text-fg-3">None</span>
        );
    return (
        <TagsField
            value={ids}
            onChange={setIds}
            entity={entity}
            canCreate={canCreate}
        />
    );
}
